import { KnowledgebaseAPI } from 'api'
import { from } from 'rxjs'
import { pluck } from 'rxjs/operators'
import { checkStatus } from 'utils/rxUtils'

export const api = {
  searchListing(phrase) {
    return from(KnowledgebaseAPI
      .get(`/search/agent/?phrase=${phrase}`))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  }
}